import React, { useEffect, useState } from 'react';
import {
  getSnackBar,
  useNotification,
  showBackdropLoader,
  pageSizeChangeHandler,
} from 'utils/commonUtils';
import { useForm } from 'react-hook-form';
import {
  getUserAllLinks,
  redirectUserLinks,
  getUserUnviewedinks,
  updateUserLinkViewStatus,
} from 'layouts/userLinks/services/linksApi';
import MDTypography from 'components/MDTypography';
import { useDispatch, useSelector } from 'react-redux';
import { intialPageSize, trainingLinkOptions } from 'constants';
import DeltaDataGrid from 'utils/CommonDataGrid/CommonDataGrid';
import { DropDownBox } from 'layouts/inventory/Inventory.styled';
import FormInputDropdown from 'components/Common/Forms/FormInputDropDown';
import { displaySnackbar } from 'components/snackbar/store/SnackbarSlice';
import { getUserLinksListData, userLinksColumns } from './getUserLinksList';
import { AttendanceHeadingBox } from 'layouts/applications/attendance/Attendance.styled';
import { setUnViewed } from 'layouts/userLinks/store/userExperienceSlice/userExperienceSlice';
import { usePermissionCustomHook } from 'layouts/users/userPermissions/utils/permissionsUtils';

const UserExperienceTab = () => {
  const { NotificationPopup, handleErrorResponse } = useNotification();
  const canAccessTasks = usePermissionCustomHook('CAN_ACCESS_TASKS');
  const dispatch = useDispatch();

  const unViewed = useSelector((state) => state?.userLinks?.unViewed);

  const [isFormLoading, setIsFormLoading] = useState(false);
  const [userAllLinks, setUserAllLinks] = useState({
    page: 1,
    rows: [],
    isLoading: false,
    pageSize: intialPageSize,
  });

  useEffect(() => {
    if (canAccessTasks) {
      fetchUserAllLinks(unViewed);
    }
  }, []);

  const defaultValue = {
    unViewed: unViewed,
  };

  const useFunction = useForm({
    mode: 'onChange',
    defaultValues: defaultValue,
  });

  const { control, register } = useFunction;

  const fetchUserAllLinks = async (unViewed = 'newLinks') => {
    try {
      setUserAllLinks((prev) => ({
        ...prev,
        isLoading: true,
      }));
      const adminAllLinksData =
        unViewed === 'allLinks'
          ? await getUserAllLinks()
          : await getUserUnviewedinks();

      setUserAllLinks((prev) => ({
        ...prev,
        isLoading: false,
        rows: getUserLinksListData(adminAllLinksData),
      }));
    } catch (error) {
      setUserAllLinks((prev) => ({
        ...prev,
        isLoading: false,
      }));
      handleErrorResponse(error?.response?.data?.message);
    }
  };

  const handleGoToLink = async (row) => {
    try {
      setIsFormLoading(true);
      const response = await redirectUserLinks(row.id);
      if (response?.url) {
        let link = response.url;
        if (!/^https?:\/\//i.test(link)) {
          link = `https://${link}`;
        }
        window.open(link, '_blank', 'noopener,noreferrer');
      }
      await fetchUserAllLinks(unViewed);
      setIsFormLoading(false);
    } catch (error) {
      setIsFormLoading(false);
      handleErrorResponse(error?.response?.data?.message);
    }
  };

  const handleUnView = async (params) => {
    const { id, status } = params?.row || {};
    const payload = {
      status: status === 'viewed' ? 'unviewed' : 'viewed',
    };
    const snackbarMessage =
      status === 'viewed'
        ? 'successfully marked as unviewed'
        : 'successfully marked as viewed';

    try {
      setUserAllLinks((prev) => ({
        ...prev,
        isLoading: true,
      }));
      await updateUserLinkViewStatus(payload, id);
      await fetchUserAllLinks(unViewed);
      setUserAllLinks((prev) => ({
        ...prev,
        isLoading: false,
      }));
      dispatch(displaySnackbar(getSnackBar(snackbarMessage)));
    } catch (error) {
      setIsFormLoading(false);
      handleErrorResponse(error?.response?.data?.message);
    }
  };

  const handleUnviewed = (e) => {
    const value = e?.target?.value;
    dispatch(setUnViewed(value));
    fetchUserAllLinks(value);
  };

  const pageSizeChange = pageSizeChangeHandler(setUserAllLinks);
  return (
    <>
      {showBackdropLoader(isFormLoading)}
      <AttendanceHeadingBox>
        <MDTypography variant="h5" fontWeight="medium">
          Training Links
        </MDTypography>
        <DropDownBox>
          <FormInputDropdown
            name="unViewed"
            type="text"
            control={control}
            options={trainingLinkOptions}
            defaultValue={defaultValue?.unViewed}
            label="Link Filter"
            register={register('unViewed', {
              onChange: (e) => {
                handleUnviewed(e);
              },
            })}
          />
        </DropDownBox>
      </AttendanceHeadingBox>
      <DeltaDataGrid
        listData={userAllLinks}
        setListData={pageSizeChange}
        columns={userLinksColumns(handleUnView, handleGoToLink)}
      />
      <NotificationPopup />
    </>
  );
};

export default UserExperienceTab;
